namespace Nobox {
    
    @Serenity.Decorators.registerEditor()
    export class PropertyTaskTriggerEditor extends Serenity.Select2Editor<object, object> {

        constructor(hidden: JQuery) {
            super(hidden, null);
            var arr = ["Contact is created", "Group is created", "Deal is crerated","Contact ownership is changed","Group ownership is changed","Deal ownership is changed"];
            arr.forEach((yz) => {
                this.addItem({ id: yz, text:yz })
            });
        }
    }
}